"use strict";

var _classCallCheck = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var luxon_1 = require("luxon");

var FileReference_1 = require("../entity/FileReference");

var StubFileReference = /*#__PURE__*/function (_FileReference_1$defa) {
  _inherits(StubFileReference, _FileReference_1$defa);

  var _super = _createSuper(StubFileReference);

  function StubFileReference() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? '123' : _ref$id,
        _ref$mimetype = _ref.mimetype,
        mimetype = _ref$mimetype === void 0 ? 'image/png' : _ref$mimetype,
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? 1234567890 : _ref$size,
        _ref$originalName = _ref.originalName,
        originalName = _ref$originalName === void 0 ? 'Rivermouth of the Sandbanks.png' : _ref$originalName,
        _ref$url = _ref.url,
        url = _ref$url === void 0 ? "dummy://belfast-entity.kaizenplatform.com/files/".concat(originalName) : _ref$url,
        _ref$createdAt = _ref.createdAt,
        createdAt = _ref$createdAt === void 0 ? luxon_1.DateTime.utc(2018, 6, 11, 9, 55, 47, 256) : _ref$createdAt;

    _classCallCheck(this, StubFileReference);

    return _super.call(this, {
      id: id,
      mimetype: mimetype,
      size: size,
      originalName: originalName,
      createdAt: createdAt,
      url: url
    });
  }

  return StubFileReference;
}(FileReference_1.default);

exports.default = StubFileReference;